export const COUNTRY_LOCALE = {
    US: { language: 'en', distanceUnit: 'mi' },
    CA: { language: 'en', distanceUnit: 'km' },
};
//# sourceMappingURL=countryLocale.js.map